import { render } from "./EmpresasSubdominios.vue?vue&type=template&id=5bf016d0"
import script from "./EmpresasSubdominios.vue?vue&type=script&lang=js"
export * from "./EmpresasSubdominios.vue?vue&type=script&lang=js"

import "./EmpresasSubdominios.vue?vue&type=style&index=0&id=5bf016d0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__